import MainLayout from "../layout/MainLayout";
import UsersDefault from "../pages/users";
import User from "../pages/user";
import OnDemand from "../pages/on-demand";
import Reports from "../pages/reports";
import TenancyManagement from "../pages/tenancy";
import SimulationDetails from "../pages/simulations/SimulationDetails";
import ContentPacks from "../pages/content-packs";
import ContentPackDetails from "../pages/content-packs/ContentPackDetails";
import Tenants from "../pages/tenant-table";
import CustomEmailTemplate from "../pages/tenancy/CustomEmailTemplate";
import CustomLandingPage from "../pages/tenancy/CustomLandingPage";
import ReportedSimEmailEditor from "../pages/tenancy/ReportedSimEmailEditor";
import DeliveryDashboard from "../pages/delivery/index";
import DeliveryRequestForm from "../pages/delivery/DeliveryRequestForm";
import DeliveryRequestDetail from "../pages/delivery/DeliveryRequestDetail";
import PresetDeliveryForm from "../pages/delivery/PresetDeliveryForm";
import DeliveryCalendarPage from "../pages/delivery/DeliveryCalendarPage";
import CourseOverview from "../pages/courses-overview";
import TenancyCourseAdd from "../pages/courses-overview/TenancyCourseAdd";
import TenancyCourseEdit from "../pages/courses-overview/TenancyCourseEdit";
import SimulationCollectionDefault from "../pages/sim-collections";
import SimulationCollectionDetails from "../pages/sim-collections/SimulationCollectionDetails";
import SimulationOverview from "pages/simulations-overview";




const TenancyAdminRoutes = {
    element: <MainLayout />,
    children: [
        {
            path: 'users',
            element: <UsersDefault />
        },
        {
            path: 'users/:id',
            element: <User />
        },
        {
            path: 'settings',
            element: <TenancyManagement />
        },
        {
            path: 'on-demand',
            element: <OnDemand />
        },
        {
            path: 'packs',
            element: <ContentPacks />
        },
        {
            path: "packs/add",
            element: <ContentPackDetails />
        },
        {
            path: "packs/edit/:id",
            element: <ContentPackDetails />
        },
        {
            path: 'reports',
            element: <Reports />
        },
        {
            path: "tenancy-courses/edit/:id",
            element: <TenancyCourseEdit />
        },
        {
            path: "tenancy-courses/add",
            element: <TenancyCourseAdd />
        },
        {
            path: "simulations/edit/:id",
            element: <SimulationDetails />
        },
        {
            path: "simulations/add",
            element: <SimulationDetails />
        },
        {
            path: "tenants",
            element: <Tenants />
        },
        {
            path: "settings/customemail",
            element: <CustomEmailTemplate />
        },
        {
            path: "settings/customlandingpage",
            element: <CustomLandingPage />
        },
        {
            path: "settings/customlandingpage",
            element: <CustomLandingPage />
        },
        {
            path: "settings/reported-sim-email",
            element: <ReportedSimEmailEditor />
        },
        {
            path: "journeybuilder",
            element: <DeliveryDashboard />
        },
        {
            path: "journeybuilder/edit/:tenancyId/:requestId",
            element: <DeliveryRequestForm isEditing={true} />
        },
        {
            path: "journeybuilder/view/:tenancyId/:requestId",
            element: <DeliveryRequestDetail />
        },
        {
            path: "journeybuilder/preset/create",
            element: <PresetDeliveryForm />
        },
        {
            path: "journeybuilder/preset/edit/:presetId",
            element: <PresetDeliveryForm isEditing={true} />
        },
        {
            path: "journeybuilder/calendar/:tenancyId/:deliveryGroupId",
            element: <DeliveryCalendarPage />
        },
        {
            path: "journeybuilder/calendar-create/:tenancyId",
            element: <DeliveryCalendarPage />
        },
        {
            path: "journeybuilder/calendar-preset/:tenancyId",
            element: <DeliveryCalendarPage />
        },
        {
            path: '/tenancy-courses',
            element: <CourseOverview />
        },
        {
            path: '/tenancy-simulations',
            element: <SimulationOverview />
        },
        {
            path: '/simulation-collections/add',
            element: <SimulationCollectionDetails />
        },
        {
            path: '/simulation-collections/edit/:id',
            element: <SimulationCollectionDetails />
        },
        {
            path: '/simulation-collections/:id',
            element: <SimulationCollectionDetails />
        }

    ]
};

export default TenancyAdminRoutes;
